import React from "react";
import { MemberListItem } from "../MemberListItem";

// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  fundraisers: IFundraiser[];
  isViewerOwner: boolean;
  groupedFundraisers: $FixMe;
  isGroups: boolean;
  refetch: () => void;
  activeReassignmentMemberId: string | null;
  setActiveReassignmentMemberId: (value: string | null) => void;
}
interface IFundraiser {
  fundraiser: {
    cursor: string;
    node: {
      id: string;
      name: string;
      userId: string;
      avatarImage: string | null;
      isOwner: boolean;
      isViewerOwner: boolean;
      joinedAt: string | null;
      deactivatedAt: string | null;
      group: $FixMe | null;
      amountRaised: {
        formatted: string;
        dollarsAmount: number;
      };
    };
  };
}

// == Constants ============================================================

MemberList.defaultProps = {};

// == Component ============================================================

export default function MemberList({
  fundraisers,
  groupedFundraisers,
  isViewerOwner,
  isGroups,
  refetch,
  activeReassignmentMemberId,
  setActiveReassignmentMemberId,
}: IProps) {
  return (
    <>
      {fundraisers.map((fundraiser: IFundraiser) => {
        const { node } = fundraiser;
        return (
          <MemberListItem
            activeReassignmentMemberId={activeReassignmentMemberId}
            fundraiser={node}
            groupedFundraisers={groupedFundraisers}
            isGroups={isGroups}
            isViewerOwner={isViewerOwner}
            key={node.id}
            refetch={refetch}
            setActiveReassignmentMemberId={setActiveReassignmentMemberId}
          />
        );
      })}
    </>
  );
}

// == Styles ===============================================================
